import { render } from "./LoginLayout.vue?vue&type=template&id=7cdaf40b&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7cdaf40b"

export default script